export const socialsData = {
    github: 'https://github.com/',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in',
}